import {asset} from 'imba';
import url from './how.png';
export default asset({
	url: url,
	type: 'image',
	width: 624,
	height: 425,
	toString: function(){ return this.url;}
})